// Bundles: Internal/Gen
import getFokusButton from '../../utils/fokusButton'
import getWorkflowNameSuffix from '../../utils/getWorkflowNameSuffix'
import getProperServiceIcon from '../../utils/getProperServiceIcon'

// import statistics from './statistics.js'
import getWorkflowRouteSuffix from '../../utils/getWorkflowRouteSuffix'

export default function (service, name, taskType, client) {
  const workflowNameAppraisal = 'appraisal'
  let workflowName = taskType.split('-').join('_')
  const workflowNameMain = workflowName
  const routePrefix = `${service}_${client}_${workflowName}`
  let workflowRoute = `${getWorkflowRouteSuffix(service, workflowName)}`

  const customBreadcrumbs = {
    taskListing: {
      meta: {
        icon: 'list',
        title: 'menu.main.list.name'
      }
    }
  }

  return [
    {
      path: `/${name}/${client}/zlecenia/${workflowRoute}`,
      name: `${routePrefix}_task_listing`,
      props: true,
      component: () => import(/* webpackChunkName: "bls-like-task-listing" */ `../../../components/bundles/share/tasksListing/Listing.vue`),
      meta: {
        acl: { service: service, action: `get_tasks_datatables__${taskType}__${client}` },
        breadcrumb: {
          list: [
            customBreadcrumbs.taskListing
          ]
        },
        client,
        icon: getProperServiceIcon(service),
        taskType: taskType,
        workflowName,
        title: `${getWorkflowNameSuffix(service, workflowName)}`,
        secondMenu: [
          {
            event: { name: `${service}:main:addTask` },
            icon: 'plus',
            label: 'Dodaj zlecenie',
            acl: { service: service, action: `post_task__create-${taskType}__${client}` }
          },
          {
            event: { name: `${service}:finance-import:spreadsheet` },
            icon: 'pocket',
            label: 'Importuj dokumenty finansowe',
            acl: { service: service, action: 'post_finance_import' }
          }
        ]
      }
    },
    {
      path: `/${name}/${client}/zlecenia/${workflowRoute}/:id`,
      props: true,
      component: () => import(/* webpackChunkName: "bls-like-task-details" */ `../../../components/bundles/${service}/MainTask/Details.vue`),
      name: `${routePrefix}_task_details`,
      meta: {
        acl: { service: service, action: `get_task__${taskType}__${client}` },
        breadcrumb: {
          dynamicLabel: true,
          list: [
            customBreadcrumbs.taskListing,
            `${routePrefix}_task_listing`
          ]
        },
        client,
        taskType: taskType,
        workflowName,
        title: 'Szczegóły zlecenia',
        secondMenu: [
          {
            event: { name: `${service}:main:changeState` },
            icon: 'skip-forward',
            label: 'Zmień status',
            acl: { service: service, action: `put_task__${taskType}_next-state__${client}` }
          },
          {
            event: { name: `${service}:main:changeAssignee` },
            icon: 'user-plus',
            label: 'Zmień opiekuna',
            acl: { service: service, action: `put_task__${taskType}__${client}` }
          },
          {
            event: { name: `${service}:main:addComment` },
            icon: 'align-left',
            label: 'Dodaj komentarz',
            acl: {
              service: service,
              action: [
                'post_comment__main_internal',
                'post_comment__main_private',
                'post_comment__main_public'
              ],
              allowOneOfActions: true
            }
          },
          getFokusButton(service, false)
        ]
      }
    },
    // {
    //   path: `/${name}/${client}/zlecenia/${workflowRoute}/:id/wyplaty/:paymentTaskId`,
    //   name: `${routePrefix}_payment_task_details`,
    //   component: () => import(/* webpackChunkName: "bls-like-task-payments" */ `../../../components/bundles/intgen/${taskType}/payment/Details`),
    //   meta: {
    //     acl: { service: service, action: 'get_payment' },
    //     breadcrumb: {
    //       list: [
    //         customBreadcrumbs.taskListing,
    //         `${routePrefix}_task_listing`,
    //         `${routePrefix}_task_details`
    //       ]
    //     },
    //     client,
    //     workflowName,
    //     title: 'Szczegóły wypłaty',
    //     secondMenu: [
    //       {
    //         event: { name: 'dashboard:menu:redirect', value: `${routePrefix}_task_details` },
    //         icon: 'arrow-left',
    //         label: 'Wróć do zlecenia',
    //         acl: { service: service, action: `get_task__${taskType}__${client}` }
    //       }
    //     ]
    //   }
    // },
    {
      path: `/${name}/${client}/zlecenia/${workflowRoute}/:id/generator-dokumentow`,
      name: `${routePrefix}_document_generator`,
      component: () => import(/* webpackChunkName: "bls-like-task-documents-editor" */ '../../../components/bundles/share/generateDocument/GenerateDocumentEditor'),
      meta: {
        acl: { service: service, action: 'get_documents_templates' },
        breadcrumb: {
          list: [
            customBreadcrumbs.taskListing,
            `${routePrefix}_task_listing`,
            `${routePrefix}_task_details`
          ]
        },
        client,
        workflowName,
        taskType: '',
        title: 'Generator Dokumentów',
        secondMenu: [
          {
            event: { name: `${service}:main:generateDocument` },
            icon: 'filepdf',
            label: 'Zapisz dokument',
            acl: { service: service, action: `put_${workflowName}_task` }
          },
          {
            event: { name: 'dashboard:menu:redirect', value: `${routePrefix}_task_details` },
            icon: 'arrow-left',
            label: 'Wróć do szczegółów',
            acl: { service: service, action: `get_task__${taskType}__${client}` }
          }
        ]
      }
    },
    {
      path: `/${name}/${client}/zlecenia/${workflowRoute}/:id/zlecenia-rzeczoznawcze/:appraisalTaskId`,
      component: () => import(/* webpackChunkName: "bls-like-appraisal-task-details" */  `../../../components/bundles/${service}/appraisal/task/Details`),
      name: `${routePrefix}_appraisal_task_details`,
      meta: {
        acl: { service: service, action: `get_task__appraisal__${client}` },
        breadcrumb: {
          dynamicLabel: true,
          list: [
            customBreadcrumbs.taskListing,
            `${routePrefix}_task_listing`,
            `${routePrefix}_task_details`
          ]
        },
        client,
        workflowNameMain,
        workflowNameAppraisal,
        taskType: 'appraisal',
        title: 'Szczegóły zlecenia rzeczoznawczego',
        secondMenu: [
          {
            event: { name: `${service}:appraisal:changeState` },
            icon: 'skip-forward',
            label: 'Zmień status',
            acl: { service: service, action: `put_task__appraisal_next-state__${client}` }
          },
          {
            event: { name: `${service}:appraisal:changeAssignee` },
            icon: 'user-plus',
            label: 'Zmień opiekuna',
            acl: { service: service, action: 'put_task' }
          },
          {
            event: { name: `${service}:appraisal:addComment` },
            icon: 'align-left',
            label: 'Dodaj komentarz',
            acl: {
              service: service,
              action: [
                'post_comment__appraisal_internal',
                'post_comment__appraisal_private',
                'post_comment__appraisal_public'
              ],
              allowOneOfActions: true
            }
          }//,
          // {
          //   event: { name: `${service}:appraisal:sendFocusSms` },
          //   icon: 'send',
          //   label: 'Fokus sms',
          //   acl: { service: service, action: 'post_focus_sms' }
          // }
          // getFokusButton(service, true)
          // {
          //   event: {name: 'intgen:appraisal:generateDocument'},
          //   icon: 'filepdf',
          //   label: 'Generuj dokument rzeczoznawczy',
          //   acl: {service: service, action: 'put_appraisal_task'}
          // }
        ]
      }
    },
    {
      path: `/${name}/${client}/zlecenia/${workflowRoute}/:id/zlecenia-rzeczoznawcze/:appraisalTaskId/generator-dokumentow-rzeczoznawczych`,
      name: `${routePrefix}_appraisal_document_generator`,
      component: () => import(/* webpackChunkName: "bls-like-task-documents-editor" */ '../../../components/bundles/share/generateDocument/GenerateDocumentEditor'),
      meta: {
        acl: { service: service },
        breadcrumb: {
          list: [
            customBreadcrumbs.taskListing,
            `${routePrefix}_task_listing`,
            `${routePrefix}_task_details`,
            `${routePrefix}_appraisal_task_details`
          ]
        },
        client,
        workflowName,
        taskType: 'appraisal',
        title: 'Generator Dokumentów',
        secondMenu: [
          {
            event: { name: `${service}:appraisal:generateDocument` },
            icon: 'filepdf',
            label: 'Zapisz dokument',
            acl: { service: service, action: 'put_appraisal_task' }
          },
          {
            event: {
              name: 'dashboard:menu:redirect',
              value: `${routePrefix}_appraisal_task_details`
            },
            icon: 'arrow-left',
            label: 'Wróć do szczegółów',
            acl: { service: service, action: 'put_appraisal_task' }
          }
        ]
      }
    },
    {
      path: `/${name}/${client}/zlecenia/${workflowRoute}/import-finansowy/zlecenie-glowne`,
      name: `${routePrefix}_finance_import_invoice_main`,
      component: () => import('../../../components/bundles/share/finance-import/InvoiceImportDetailsMain'),
      meta: {
        acl: { service: service, action: 'post_finance_import' },
        breadcrumb: {
          list: [
            customBreadcrumbs.taskListing,
            `${routePrefix}_task_listing`
          ]
        },
        client,
        workflowName,
        title: 'Import danych finansowych',
        secondMenu: [
          {
            event: { name: `${service}:finance-import:main` },
            icon: 'file',
            label: 'Importuj dokumenty',
            acl: { service: service, action: 'post_finance_import' }
          },
          {
            event: {
              name: 'dashboard:menu:redirect',
              value: `${routePrefix}_task_listing`
            },
            icon: 'arrow-left',
            label: 'Wróć do szczegółów',
            acl: { service: service, action: `get_tasks_datatables__${taskType}__${client}` }
          }
        ]
      },
      children: [
        {
          path: 'podsumowanie',
          name: `${routePrefix}_finance_import_invoice_main_summary`,
          component: () => import('../../../components/bundles/share/finance-import/InvoiceImportDetailsMain'),
          meta: {
            acl: { service: service, action: 'post_finance_import' },
            breadcrumb: {
              list: [
                customBreadcrumbs.taskListing,
                `${routePrefix}_task_listing`
              ]
            },
            client,
            title: 'Import danych finansowych - Podsumowanie',
            workflowName,
            secondMenu: [
              {
                event: {
                  name: 'dashboard:menu:redirect',
                  value: `${routePrefix}_task_listing`
                },
                icon: 'arrow-left',
                label: 'Wróć do listy zleceń',
                acl: { service: service, action: `get_tasks_datatables__${taskType}__${client}` }
              }
            ]
          }
        }
      ]
    },
    {
      path: `/${name}/${client}/zlecenia/${workflowRoute}/import-finansowy/zlecenie-rzeczoznawcze`,
      name: `${routePrefix}_finance_import_invoice_appraisal`,
      component: () => import('../../../components/bundles/share/finance-import/InvoiceImportDetailsAppraisal'),
      meta: {
        acl: { service: service, action: 'post_finance_import' },
        breadcrumb: {
          list: [
            customBreadcrumbs.taskListing,
            `${routePrefix}_task_listing`
          ]
        },
        client,
        workflowName,
        title: 'Import danych finansowych',
        secondMenu: [
          {
            event: { name: `${service}:finance-import:appraisal` },
            icon: 'file',
            label: 'Importuj dokumenty',
            acl: { service: service, action: 'post_finance_import' }
          },
          {
            event: {
              name: 'dashboard:menu:redirect',
              value: `${routePrefix}_task_listing`
            },
            icon: 'arrow-left',
            label: 'Wróć do szczegółów',
            acl: { service: service, action: `get_tasks_datatables__${taskType}__${client}` }
          }
        ]
      },
      children: [
        {
          path: 'podsumowanie',
          name: `${routePrefix}_finance_import_invoice_appraisal_summary`,
          component: () => import('../../../components/bundles/share/finance-import/InvoiceImportDetailsAppraisal'),
          meta: {
            acl: { service: service, action: 'post_finance_import' },
            breadcrumb: {
              list: [
                customBreadcrumbs.taskListing,
                `${routePrefix}_task_listing`
              ]
            },
            client,
            workflowName: workflowName,
            title: 'Import danych finansowych - Podsumowanie',
            secondMenu: [
              {
                event: {
                  name: 'dashboard:menu:redirect',
                  value: `${routePrefix}_task_listing`
                },
                icon: 'arrow-left',
                label: 'Wróć do listy zleceń',
                acl: { service: service, action: `get_tasks_datatables__${taskType}__${client}` }
              }
            ]
          }
        }
      ]
    },
    // ...statistics(service, name, workflowName, client, taskType)
  ]
}
